<template>
    <section>
        <v-btn @click="AddCourseVideoDialog">Add Course Videos</v-btn>
        <v-btn @click="AddCourseImageDialog">Add Course Images</v-btn>
        <app-add-course-image ref="GetPreviewVideo" :dialog='AddCourseImage' @close='CloseDailog'></app-add-course-image>
        <app-add-course-video  ref="GetCourseVideo" :dialog='AddCourseVideo' @close='CloseDailog'></app-add-course-video>
        <app-videos-section></app-videos-section>
    </section>
</template>
<script>

import appAddCourseImage from '../views/dialogs/AddCourseImage'
import appAddCourseVideo  from '../views/dialogs/AddCourseVideo'
import appVideosSection   from '../views/tables/VideosSection'

export default {
    components:{
        appAddCourseImage,
        appAddCourseVideo,
        appVideosSection
    },
    data(){
        return {

            AddCourseImage : false,
            AddCourseVideo  : false
        }
    },
    methods:{

        CloseDailog(){

            this.AddCourseImage = false
            this.AddCourseVideo  = false
        },
        AddCourseImageDialog(){

            this.AddCourseImage = true
            this.$refs.GetPreviewVideo.GetCourseListFromDB()
        },
        AddCourseVideoDialog(){
            
            this.AddCourseVideo = true
            this.$refs.GetCourseVideo.GetCourseListFromDB()
            //  as per AddCurriculam.vue
            this.$refs.GetCourseVideo.GetCourseDetailsList()
        }
    },
    mounted(){
        this.$eventHub.$emit("LOADING",'false')
    }
    
}
</script>
<style scoped>

</style>
